(ns rothko.component.error-boundary
  (:require [reagent.core :as r]))

(defn error-boundary
  [comp]
  (let [error (r/atom {:error? false
                       :message nil})]
    (r/create-class
     {:component-did-catch
      (fn [_ _ _] true)
      :get-derived-state-from-error
      (fn [error-message]
        (reset! error {:error? true
                       :message (or (.-message error-message) error-message)}))
      :reagent-render
      (fn inner [comp]
        (if (:error? @error)
          [:div
           "Error in component: "
           (:message @error)
           " "
           [:a {:href "#" :on-click #(swap! error assoc :error? false)} "[Render component again]"]]
          comp))})))

(defn with-error-boundary
  [component]
  (fn error-wrapper [props & children]
    [error-boundary
     (into [component props] children)]))
